export const renderData = (actual, goal) => {
    const isFull = actual >= goal
    const dataArray = isFull ? [actual] : [actual, (goal - actual)]

    return {
        maintainAspectRatio: true,
        responsive: true,
        datasets: [
            {
                data: dataArray,
                backgroundColor: ['rgb(102, 255, 204)', 'rgb(20, 38, 67)'], // @NOTE: --color-green, --color-blue-dark
            }
        ]
    };
}

export const renderOptions = () => ({
    legend: {
        display: false,
    },
    plugins: {
        tooltip: {
            enabled: false,
            filter: function () { return false },
        },
    },
    elements: {
        arc: {
            borderWidth: 5
        }
    },
    responsive: true,
    cutout: '95%',
    maintainAspectRatio: true,
})